export default "__VITE_ASSET__hMKk7uHt__"